import React from 'react';
import MvModal from "Generic/MvModal";
import ToolTip from "Generic/ToolTip";
import './MyAddWaitlistModal.sass';
import { numberWithCommas } from 'Utils';

interface Props {
    openModal: boolean
    toggleAddToWaitlistModal: () => void
    gotoWaitlistAYP: (waitListID: number) => void
}

interface State {
    itemSelected: boolean
    item: any
}

const mockData = [   
    {
        "waitlistId": 16901,
        "ownerId": "A20001386",
        "cieId": null,
        "ownerBenefitLevel": "Presidential",
        "status": {
            "code": "CREATED"
        },
        "lastUpdateDate": "2021-08-26",
        "roomType": "TOVI",
        "voaEid": "1234564",
        "confirmationNumber": null,
        "propertyCode": "BKKEP",
        "numberOfNights": 3,
        "checkInStartDate": "2022-08-21",
        "checkInEndDate": "2022-08-21",
        "expiryDate": "2022-06-22",
        "maxPointsToApply": 6600,
        "resortId": "BKKEP",
        "code": "BK",
        "universalPropertyCode": "BKBKKEP",
        "name": "Marriott Vacation Club® at The Empire Place©",
        "continent": "Asia",
        "country": "Thailand",
        "activities": [
            {
                "name": "Urban",
                "photo": "https://content.vistana.com/files/live/sites/vistana-digital-content-manager/files/images/map/locale/17-OOC-1265-Hawaii-Destination-Mediabakery_NGF0070894_ret-16x9.png"
            }
        ],
        "state": "Bangkok",
        "city": "Yannawa, Sathorn",
        "resortImage": "https://content.vistana.com/files/live/sites/vistana-digital-content-manager/files/images/properties/Marriott Vacation Club/BKKEP/21-108-772433_EmpirePlace_hero_BEP-P-001_4_3.png",
        "tswSiteId": 1008,
        "minTotalPoints": 2500,
    }
]
class MvAddWaitlistModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            itemSelected: false,
            item: null,
        }
        this.selectNewItem = this.selectNewItem.bind(this)
        this.selectItem = this.selectItem.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.continueToAYP = this.continueToAYP.bind(this)
    }

    waitlistItem(waitlist: any) {
        return (
            <div className="waitlist-select-section dashed-bottom-border">
                <input type="radio" name="addWaitlistRadioButtons" onChange={() => this.selectItem(waitlist)} />
                <div className="waitlist-info-section">
                    <img src="https://content.vistana.com/files/live/sites/vistana-digital-content-manager/files/images/properties/Marriott Vacation Club/BKKEP/21-108-772433_EmpirePlace_hero_BEP-P-001_4_3.png" width="114" height="114" />
                    <div style={{
                        width: '100%',
                        marginLeft: '.5rem',
                    }}>
                        <div className="waitlist-header">
                            <div className="left">
                                <span className="waitlist-title">
                                    Waitlist {`#12345678`}
                                </span>
                            </div>
                            <div className="right"> 
                                <div className="total-points-section">
                                    <span className="total-points-text">Total Points Needed</span>
                                    <ToolTip
                                        useRefToPosition={false}
                                        tabIndex={2}
                                        tip={[
                                            {
                                                label: "",
                                                desc: "Total points needed"
                                            }
                                        ]}
                                        id={`mv-toggle-tooltip-total-points-needed`}
                                    >
                                        <span className="question-icon">{"?"}</span>
                                    </ToolTip>
                                    <div className="total-points-range">
                                        {
                                            waitlist.minTotalPoints < 9999
                                            ? `${numberWithCommas(waitlist.minTotalPoints)} - 9,999`
                                            : `9,999`
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="waitlist-body">
                            <a href="javascript;:" className="waitlist-resort-link">Marriot's Kolina Club House</a>
                            <div className="row">
                                <div className="left">
                                    <p className="waitlist-resort-name">Kapolei - Oahu, Hawaii USA</p>
                                    <p className="waitlist-resort-info">
                                        <b>Room Type:</b> Multiple
                                    </p>
                                    <p className="waitlist-resort-info">
                                        <b>Check-In Date(s):</b>  01 Nov 2020 - 30 Nov 2020
                                    </p>
                                </div>
                                <div className="right">
                                    <p className="waitlist-resort-info">
                                        <b>Segment:</b>  1 Of 1
                                    </p>    
                                    <p className="waitlist-resort-info">
                                        <b># Of Nights:</b>  4 Nights
                                    </p>
                                    <p className="waitlist-resort-info">
                                        <b># Of Guests:</b>  3 Guests
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    selectNewItem() {
        this.setState({
            itemSelected: true,
            item: "New", 
        })
    }
    
    selectItem(waitlsit: any) {
        this.setState({
            itemSelected: true,
            item: waitlsit,
        })
    }

    toggleModal() {
        this.setState({
            itemSelected: false,
        })
        this.props.toggleAddToWaitlistModal()
    }

    continueToAYP() {
        const { item } = this.state;

        if (item === 'New') {
            this.props.gotoWaitlistAYP(368193)
        }
        else if(item !== null) {
            //Call API to add waitlist request to waitlist
            this.props.gotoWaitlistAYP(368193)
        }
    }

    render() {
        return (
            <MvModal openModal={this.props.openModal} toggleModal={this.toggleModal} iconColor="#ccc">
                <div className='waitlist-modal-container'>
                    <div className='waitlist-modal-header'>
                        <p className="waitlist-modal-title">Would you like to add to an existing waitlist?</p>
                        <p className="waitlist-modal-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras fringilla interdum enim, nec dictum tellus semper et. Vestibulum malesuada mi elit, a congue mauris commodo in. Aenean lacinia bibendum nulla sed consectetur.</p>
                    </div>
                    <div>
                    {
                        mockData.map((value) => {
                            return this.waitlistItem(value)
                        })
                    }
                    </div>
                    <div className="waitlist-select-section solid-bottom-border">
                        <input type="radio" name="addWaitlistRadioButtons" onChange={this.selectNewItem} />
                        <span style={
                            {
                                marginLeft: '1rem',
                            }
                        }>
                            No, Create a new Waitlist
                        </span>
                    </div>
                    <button 
                        className={this.state.itemSelected ? "continue-button form-action-button mv-button primary" : "continue-button form-action-button mv-button primary disabled"} 
                        tabIndex={7} 
                        disabled={!this.state.itemSelected} 
                        type="button"
                        onClick={this.continueToAYP}
                    >
                      <span className="continue-text">Continue</span>
                    </button>
                </div>
            </MvModal>
        )
    }
}

export {
    MvAddWaitlistModal
};